import { UseAxiosOptions, useAxios } from '@vueuse/integrations/useAxios';
import { AxiosRequestConfig } from 'axios';

type FetchOptions<T> = AxiosRequestConfig<T> &
   UseAxiosOptions<T> & { transformApiRequest?: boolean; public?: boolean; cancelable?: boolean };

function getTransformResponse<T>(config: FetchOptions<T>) {
   if (config.transformResponse) {
      return config.transformResponse;
   } else if (config.transformApiRequest) {
      return (response: string) => {
         try {
            return JSON.parse(response).data;
         } catch {
            return response;
         }
      };
   } else {
      return undefined;
   }
}

export function useFetch<T>(url: string, config: FetchOptions<T> = {}) {
   return useAxios<T>(url, { ...config, transformResponse: getTransformResponse(config) }, config.public ? publicHttp : http, {
      immediate: true,
      ...config,
   });
}

export function usePost<T>(url: string, config: FetchOptions<T> = {}) {
   return useAxios<T>(
      url,
      { ...config, transformResponse: getTransformResponse(config), method: 'post' },
      config.public ? publicHttp : http,
      {
         immediate: false,
         ...config,
         abortPrevious: false,
      },
   );
}

export function usePut<T>(url: string, config: FetchOptions<T> = {}) {
   return useAxios<T>(
      url,
      { ...config, transformResponse: getTransformResponse(config), method: 'put' },
      config.public ? publicHttp : http,
      {
         immediate: false,
         ...config,
         abortPrevious: false,
      },
   );
}

export function usePatch<T>(url: string, config: FetchOptions<T> = {}) {
   return useAxios<T>(
      url,
      { ...config, transformResponse: getTransformResponse(config), method: 'patch' },
      config.public ? publicHttp : http,
      {
         immediate: false,
         ...config,
         abortPrevious: false,
      },
   );
}

export function useDelete<T>(url: string, config: FetchOptions<T> = {}) {
   return useAxios<T>(
      url,
      { ...config, transformResponse: getTransformResponse(config), method: 'delete' },
      config.public ? publicHttp : http,
      {
         immediate: false,
         ...config,
         abortPrevious: false,
      },
   );
}
